import { takeLatest } from 'redux-saga/effects';
import {
  CASE_STATUS_START,
  GET_CASE_AND_SERVICE_STATUS,
} from 'redux/actions/types';
import {
  getCaseStatusSaga,
  getCaseAndServiceStatusSaga,
} from './case-status-saga';

export default function* caseStatusSaga() {
  yield takeLatest(CASE_STATUS_START, getCaseStatusSaga);
  yield takeLatest(GET_CASE_AND_SERVICE_STATUS, getCaseAndServiceStatusSaga);
}
